import React, { Component, useContext } from "react";
import { Link } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UserService from "../../../services/UserService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import "./InventoryWidget.scss";
import UserTypesEnum from "../../../models/UserTypesEnum";
import styled from "styled-components";
import { Socket } from "socket.io-client";
import UserContext from "../../../contexts/UserContext";
import UIService from "../../../services/UIService";
import ICatalog_Item from "../../../models/ICatalog_Item";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    lastFiveStock: Partial<ICatalog_Item>[];
    isMainViewLight?: boolean;
    inEditor?: boolean;
    removeWidget?: () => void;
};

export const InventoryWidget = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const isMainViewLight = UIService.isMainViewLight();

    if (!props.lastFiveStock) {
        // Do nothing?
    }
    if (userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.SHIP_MGMT) {
        return null;
    }

    const showInventoryDetails = UserService.showInventoryDetails(supplierModel, userModel);

    const tableBody = props.lastFiveStock.map((partialCatItem: any, index: number) => {
        const last_updated = UserService.parseLastUpdated(partialCatItem.updated_at);

        let qty_on_hand: any = 0;

        if (!partialCatItem.allow_backorder) {
            if (partialCatItem.qty_on_hand) {
                qty_on_hand = showInventoryDetails? partialCatItem.qty_on_hand : partialCatItem.qty_on_hand > 0 ? "Y" : "N";
            } else {
                qty_on_hand = (
                    <span className="fa-stack fa-sm">
                        <i className="fas fa-box fa-stack-1x"></i>
                        <i className="fas fa-ban fa-stack-2x faded-orange"></i>
                    </span>
                );
            }
        } else {
            if (partialCatItem.qty_on_hand > 0) {
                qty_on_hand = showInventoryDetails? partialCatItem.qty_on_hand : partialCatItem.qty_on_hand > 0 ? "Y" : "N";
            } else {
                qty_on_hand = "BACKORDER";
            }
        }

        return (
            <tr key={index}>
                <td>
                    <div>{partialCatItem.name}</div>
                    <DescriptionDiv
                        className={"text-small text-muted m-h-5r overflow-hidden"}
                        dangerouslySetInnerHTML={{ __html: partialCatItem.description }}></DescriptionDiv>
                </td>
                <td className={"d-none d-lg-table-cell"}>{partialCatItem.sku}</td>
                <td className={"text-center"}>{qty_on_hand}</td>
                <td className={"d-none d-md-table-cell"}>{last_updated}</td>
            </tr>
        );
    });

    let stockLevels: any = (
        <div className={"d-flex justify-content-center align-items-center flex-grow"}>
            <OwLabel title={"dashboard.no_stock_levels"} />
        </div>
    );

    stockLevels = (
        <div className="stock-levels dashboard-widget w-100 " style={{ minHeight: props.inEditor ? "" : "275px" }}>
            <div className={"d-flex w-100 justify-content-between align-items-center ps-2 pe-2"}>
                <OwTitle tag={"h4"} title={"inventory"} />
                {props.inEditor ? (
                    <span>
                        <OwLabel title={"view"} />{" "}
                        <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger"} fn={props.removeWidget!} />
                    </span>
                ) : (
                    <Link title={"inventory"} className={"pointer"} to={"/inventory"}>
                        <OwTranslate id={"view"} defaultMessage={"View"} />
                    </Link>
                )}
            </div>
            <table className={"table table-striped table-sm " + (isMainViewLight ? "" : "table-dark")}>
                <thead>
                    <tr className={isMainViewLight ? "" : "dark-header"}>
                        <th>
                            <OwLabel tabIndex={0} title={"name"} />
                        </th>
                        <th className={"d-none d-lg-table-cell"}>
                            <OwLabel tabIndex={0} title={"sku"} />
                        </th>
                        <th className={"text-center"}>
                            <OwLabel title={"stock"} />
                        </th>
                        <th className={"d-none d-md-table-cell"}>
                            <OwLabel title={"last_updated"} />
                        </th>
                    </tr>
                </thead>
                <tbody>{tableBody}</tbody>
            </table>
        </div>
    );

    return <div className={"InventoryWidget dashboard-widget mt-4 mt-md-0 d-flex justify-content-start widget h-100"}>{stockLevels}</div>;
};

const DescriptionDiv = styled.div`
    max-height: 3rem;
`;
